import script from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingPlanPage.vue?vue&type=style&index=0&id=748e178c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748e178c"]])

export default __exports__